import { Show } from "zyra";
import { createSiteState } from "./site-state";
import { useSiteBehavior } from "./use-site-behavior";
import { DocsLayout } from "./DocsLayout";
import { LandingPage } from "../landing/LandingPage";
import { SearchDialog } from "../components/SearchDialog";

export function App() {
  const site = createSiteState();
  useSiteBehavior(site);
  return (
    <>
      {() =>
        site.pathname.value === "/" ? (
          <LandingPage site={site} />
        ) : (
          <DocsLayout site={site} />
        )
      }
      <Show when={site.searching.value}>
        <SearchDialog site={site} />
      </Show>
    </>
  );
}
